<section class="page-title" style="background-image: url(assets/images/breadcom.png);">
  <div class="auto-container">
    <div class="content-box">
      <div class="row">
        <div class="col-6">
          <div class="title">
            <h1> Change Password</h1>
          </div>
        </div>
        <div class="col-6">


          <ul class="bread-crumb clearfix text-right">
            <li><a routerLink="/">Home</a></li>
            <li> Change Password</li>
          </ul>
        </div>

      </div>

    </div>
  </div>
</section>


<div id="main-wrapper" class="oxyy-login-register">
  <div class="container-fluid">
    <div class="row g-0 banner-inactive" *ngIf="userInfo.id > 0 && (userInfo.email == null || userInfo.email == '')">
      Your email is missing. Please contact the support team at&nbsp; <a style="color: #fff;text-decoration:underline" href="mailto:general@anmw.co.uk">general&#64;anmw.co.uk</a> &nbsp;
    </div>

    <div class="row g-0 min-vh-100">
      <!-- Welcome Text
          ========================= -->
      <div class="col-md-6">
        <div class="hero-wrap d-flex align-items-center h-100">
          <div class="hero-mask opacity-8 bg-primary"></div>

          <div class="hero-content w-100 min-vh-100 d-flex flex-column">

            <div class="row g-0 my-auto">
              <div class="col-10 col-lg-9 mx-auto">
                <h1 class="text-11  mb-4"><span>ANMW</span> National Distribution Monitor</h1>
                <p class="text-4  lh-base mb-5">Welcome to the ANMW National Distribution Monitor which provides
                  constantly updated
                  information on national newspaper distribution throughout the UK</p>

                <img src="./assets/images/loginimg.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Welcome Text End -->

      <!-- Login Form
          ========================= -->
      <div class="col-md-6 d-flex">
        <div class="container">
          <div class="row g-0">
            <div class="col-10 col-lg-10 col-xl-9 mx-auto">
              <div class="main_login" [hidden]="userInfo.email == null || userInfo.email == ''">
                <h3 class="fw-600 ">Change Password</h3>
                <p></p>
                <form id="resetpassword" class="mt-4" [formGroup]="form" (ngSubmit)="submitPage()">
                  <!-- <div class="mb-2" *ngIf="userInfo.id > 0 && (userInfo.email == null || userInfo.email == '')">
                    <label for="emailAddress" class="form-label">Email</label>
                    <input type="text" formControlName="email" class="form-control" id="email" required
                      placeholder="Enter Email">
                      <div
                      *ngIf="this.form.get('email')?.errors?.['required']  && (form.controls['email'].dirty|| form.controls['email'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Email is required.
                    </div>

                    <div
                      *ngIf="this.form.get('email')?.errors?.['pattern']  && (form.controls['email'].dirty|| form.controls['email'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Email is not valid.
                    </div>
                  </div> -->
                  
                  <div class="mb-2" >
                    <label for="emailAddress" class="form-label">Old Password</label>
                    <input type="password" formControlName="oldPassword" class="form-control" id="oldPassword" required
                      placeholder="Enter Old Password">
                    <div
                      *ngIf="this.form.get('oldPassword')?.errors?.['required']  && (form.controls['oldPassword'].dirty|| form.controls['oldPassword'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Old Password required.
                    </div>
                  </div>
                  <div class="mb-2">
                    <label for="newPassword" class="form-label">New Password</label>
                    <input type="password" formControlName="newPassword" class="form-control" id="newPassword" required
                      placeholder="Enter New Password">

                    <div
                      *ngIf="this.form.get('newPassword')?.errors?.['required']  && (form.controls['newPassword'].dirty|| form.controls['newPassword'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      New Password required.
                    </div>

                    <div
                      *ngIf="this.form.controls['newPassword']?.value?.length > 0 && this.form.get('newPassword')?.errors?.['strong']  && (form.controls['newPassword'].dirty|| form.controls['password'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Password should have 12 characters length and atleast one number, one
                      lowercase and upper case letter and special characters
                    </div>
                  </div>
                  <div class="mb-2">
                    <label for="confirmPassword" class="form-label">Confirm Password</label>
                    <input type="password" formControlName="confirmPassword" class="form-control" id="confirmPassword"
                      required placeholder="Enter Confirm Password">

                      <div
                      *ngIf="this.form.get('confirmPassword')?.errors?.['required']  && (form.controls['confirmPassword'].dirty|| form.controls['confirmPassword'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Confirm Password required.
                    </div>

                    <div
                      *ngIf="this.form.controls['confirmPassword'].value != '' && this.form.controls['newPassword'].value != '' && this.form.controls['newPassword'].value != this.form.controls['confirmPassword'].value   && (form.controls['confirmPassword'].dirty|| form.controls['confirmPassword'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      New Password and Confirm Password should be same.
                    </div>
                  </div>
                  <div class="row">

                    <div class="col-12">

                      <div class="d-grid text-right">
                        <button type="button" (click)="reset()" class="theme-btn style-one">Reset</button>
                        <button [disabled]="userInfo.email == null || userInfo.email == ''" type="submit" class="theme-btn style-two">Update Password</button>
                      </div>
                    </div>
                  </div>

                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Login Form End -->
    </div>
  </div>
</div>